<ng-container *ngIf="isLoad">
    <div id="editor" [formGroup]="group" class="form-field-margin-bottom" [class.wysiwyg-disabled]="field?.disabled">
        <angular-editor
            [config]="editorConfig"
            [formControlName]="field.name"
            [field]="field"
            [group]="group"
            [placeholder]="field.label + (field.required ? ' *' : '')"
        >
        </angular-editor>
        <ng-container *ngIf="(field?.hint ?? '') !== ''">
            <mat-hint [innerHtml]="field.hint" class="truncate text-xxs px-2" [title]="field.hint"></mat-hint>
        </ng-container>
        <ng-container *ngIf="(field?.maxlength ?? 0) !== 0">
            <div class="maxlength-hint">{{ group?.get(field?.name)?.value?.length }} / {{ field?.maxlength }}</div>
        </ng-container>
        <ng-container
            *ngFor="
                let validation of [
                    {
                        name: 'required',
                        message: appService.language_dictionary.system_field_required,
                    },
                    {
                        name: 'maxlength',
                        message:
                            appService.language_dictionary.system_field_max_length +
                            ' ' +
                            field.maxlength +
                            ' ' +
                            appService.language_dictionary.system_field_symbols,
                    },
                ]
            "
            ngProjectAs="mat-error"
        >
            <mat-error
                *ngIf="group.get(field.name).touched && group.get(field.name).hasError(validation.name)"
                [innerHTML]="
                    validation.name === 'serverError' ? group.get(field.name).errors?.serverError : validation.message
                "
                class="text-xs"
            >
            </mat-error>
        </ng-container>
    </div>
</ng-container>
